import UserSupportPageComponent from './component'

const UserSupportPage: React.FC = (): React.ReactElement => {
	return <UserSupportPageComponent />
}
export default UserSupportPage
